// extracted by mini-css-extract-plugin
export default {"container":"CanvasInput_container__fo-tp","canvas":"CanvasInput_canvas__Daj6R","overlay":"CanvasInput_overlay__Xmlak"};